export const animationContainer = {
  visible: {
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.3,
      ease: "easeOut",
    }
  },
  none: {
    transition: {
      staggerChildren: 0,
    }
  }
}

export const fadeUpItem = {
  visible: { opacity: 1, y: 0, transition: { ease: "easeOut", duration: 1 } },
  hidden: { opacity: 0, y: 30 },
  none: { opacity: 1, y:0, transition: { duration: 0 }}
}

export const fadeDownItem = {
  visible: { opacity: 1, y: 0, transition: { ease: "easeOut", duration: 1.5 } },
  hidden: { opacity: 0, y: -30 },
  none: { opacity: 1, y:0, transition: { duration: 0 }}
}

export const fadeUpItemClass = "nimbus-web--fade-up-item";

export function filterByCategories(obj, key, lang = "es") {
  return obj.allSanityComponent.edges.filter(
    (e) => e.node.category.title[lang] === key
  );
}
